import { render, staticRenderFns } from "./vpd-banklist-panel.vue?vue&type=template&id=69a4d72a"
import script from "./vpd-banklist-panel.vue?vue&type=script&lang=js"
export * from "./vpd-banklist-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports